// src/components/store/sections/hero-banner/HeroV62AsymmetricduoCrimsonRose.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV62AsymmetricduoCrimsonRose(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={62}
      archKey="asymmetric_duo"
      archLabel="Asymmetric Dual Deck"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      {...props}
    />
  );
}
